"use strict";
import { apply, fromAutomerge } from "cabbages";
export default function autoproduce(payload) {
  return (doc) => {
    for (let patch of payload.patches) {
      apply(doc, ...fromAutomerge(patch, payload));
    }
  };
}
//# sourceMappingURL=autoproduce.js.map
